export default __webpack_public_path__ + "static/media/videoposter.8c8a40f4.jpg";